import { ConfirmDialog } from '@sendoutcards/quantum-design-ui'
import { useState } from 'src/hooks'

export type AddPhoneNumberToAccountProps = {
  addPhoneToAccount: () => Promise<string | undefined>
  onClose: () => void
}

export const AddPhoneNumberToAccount: React.FC<
  AddPhoneNumberToAccountProps
> = props => {
  const [isAdding, setIsAdding] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>()

  const addPhoneToAccount = async () => {
    setIsAdding(true)
    try {
      const newErrorMessage = await props.addPhoneToAccount()
      setErrorMessage(newErrorMessage)
    } finally {
      setIsAdding(false)
    }
  }

  return (
    <ConfirmDialog
      primaryAction="accept"
      accept={{
        title: 'Yes',
        onClick: addPhoneToAccount,
        isDisabled: isAdding,
      }}
      decline={{
        title: 'No',
        onClick: props.onClose,
      }}
      title={'Gift card linked succesfully'}
      description={
        'Do you want to add this phone number to your account?' +
        (errorMessage
          ? '\nThere was an error: ' + errorMessage.slice(0, 32) + '...'
          : '')
      }
      isOpen={true}
    />
  )
}
